module.exports = __webpack_public_path__ + "static/img/upload.eca388b1.png";